import { DEFAULT_CONFIG } from './constants/general';
import { CLD_RESOURCES_ROOT } from './constants/paths';
import { Config, TextPresetName, TextPresetState } from './types';

export const getConfigFromHashParams = (window: Window) => {
  const hashParams = decodeURIComponent(window.location.hash.substr(1));
  let config;
  try {
    config = JSON.parse(hashParams) as Config;
  } catch (e) {
    config = DEFAULT_CONFIG;
    window.location.hash = JSON.stringify(config);
  }
  return config;
};

export const getThemePath = (config: Config, themeIndex: number) =>
  `${config.themesPath}/${config.themes[themeIndex].name}`;

export const getPublicId = (type: 'asset' | 'logo' | 'overlay', config: Config, themeIndex: number, dataName: string) =>
  `${getThemePath(config, themeIndex)}/${type}s/${dataName}`;

// todo use @cld/sdk-client-wrapper
// See https://cloudinary.com/documentation/image_transformations#transforming_media_assets_using_dynamic_urls
export const getCldImageUrl = (cloudName: string, transformation: string, publicId: string) =>
  `${CLD_RESOURCES_ROOT}${cloudName}/image/upload/${transformation}/${publicId}`;

// Setting DPR to prevent from blurry images on devices with DPR higher that 1.
// See https://cloudinary.com/documentation/image_transformations#set_device_pixel_ratio_dpr
export const getCldImageSizeTransformation = (width: number, height: number) =>
  `w_${width},h_${height},dpr_${window.devicePixelRatio}`;

type RecordKey = number | string;

export const toggleAndKeepOne = (
  record: Record<string, boolean>,
  keyToToggle: RecordKey,
  requiredValue = true,
  firstKey: RecordKey = 0,
  secondKey: RecordKey = 1,
) => {
  const changingFirstKey = keyToToggle === firstKey;
  const toggledRecord = { ...record, [keyToToggle]: !record[keyToToggle] };

  const includesRequiredValue = Object.values(toggledRecord).includes(requiredValue);
  if (!includesRequiredValue) {
    const keyToRetoggle = changingFirstKey ? secondKey : firstKey;
    toggledRecord[keyToRetoggle] = requiredValue;
  }

  return toggledRecord;
};

export const calculateTextPresets = (textPresets: TextPresetState, index: number) => {
  const defaultState = ({
    ...Object.keys(textPresets).map((key) => textPresets[key as TextPresetName]),
  } as unknown) as Record<string, boolean>;

  const updatedState = toggleAndKeepOne(defaultState, index, true);
  const newTextPresets: TextPresetState = { ...textPresets };
  Object.keys(textPresets).forEach((key, indyk) => {
    newTextPresets[key as TextPresetName] = updatedState[indyk];
  });
  return newTextPresets;
};
